import { DefaultService } from '@/services/DefaultService';

export default class TipoRtrService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    save(tiportr, contexto = "agro") {
        return this._http.post(`${this._env}/${contexto}/tiportr`, tiportr, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id, contexto = "agro") {
        return this._http.get(`${this._env}/${contexto}/tiportr/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/agro/tiportr/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(column = 'descricao', order = 'asc', page = 0, limit = 50, situacao = 2, contexto = "agro", ...params) {
        return this._http.get(encodeURI(`${this._env}/${contexto}/tiportr.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacao(Tiportr, contexto = "agro") {
        return this._http.post(`${this._env}/${contexto}/tiportr/updatesituacao`, Tiportr, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllCombo(params) {
        return this.findAllComboSituacao(1, params)
    }

    findAllComboSituacao(situacao = 1, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/tiportr/getcombo.json?situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

}